var page_awards = {
  data: {},
  data_featured: [],
  init: function() {
    $.ajax({
      url: window.gpb.page_awards.json_url,
    }).done((data, status, xhr) => {
      page_awards.data = data;
      page_awards.initEl();
    }).fail((xhr, status, err) => {

    }).always((data, status, xhr) => {

    });
  },
  initEl: function() {
    var awards = page_awards.data.awards
    awards.forEach(function(award, i) {
      award.regions = award.regions.split('|');

      awards[i] = award;
    });
    
    var available_awards = awards.filter(function(award) {
      return award.category != '' && award.regions != '' && award.active;
    });

    var featured_awards = available_awards.filter(function(award) {
      return award.is_featured;
    }).sort(function(a, b) {
      return b.year - a.year || a.month - b.month;
    });
    var featured_html = Handlebars.compile($('#tpl-award-featured').html())({
      awards: featured_awards,
      texts: window.gpb.page_awards.texts,
    });
    $('.award-featured').append(featured_html);

    var categories_awards = Object.groupBy(available_awards, function(award) {
      return award.category;
    });
    var is_accordion_open = false;
    $('.award-listing').each(function(i) {
      var _t = $(this),
          key = _t.attr('data-key'),
          
          category_awards = categories_awards[key] || [];
        
      if (category_awards.length == 0) {
        _t.remove();
        return; 
      }

      if (!is_accordion_open) {
        is_accordion_open = true;
        $('.award-listing-header', _t).addClass('active');
      }

      category_awards = category_awards.sort(function(a, b) {
        return b.year - a.year || b.month - a.month;
      });

      var first_award = category_awards[0];

      $('.award-listing-total', _t).html(category_awards.length);

      var categories_html = Handlebars.compile($('#tpl-award-listing').html())({
        first_award: first_award,
        awards: category_awards,
        texts: window.gpb.page_awards.texts,
      });

      var total_left = category_awards.length - 12;
      var $categories_html = $(categories_html);
      $('.award-listing-total-left', $categories_html).html(total_left);
      if (total_left <= 0) {
        $('.award-listing-table-more', $categories_html).remove();
      }

      _t.append($categories_html.get(0).outerHTML);
    });

    // Object.keys(categories_awards).forEach(function(category_name) {
    //   var category_awards = categories_awards[category_name].sort(function(a, b) {
    //     return b.year - a.year || b.month - a.month;
    //   });
    //   categories_awards[category_name] = {
    //     settings: {
    //       total: category_awards.length,
    //       title: category_name,
    //     },
    //     awards: category_awards,
    //   }
    // });
  },
}
$(function() {
  page_awards.init();

  $('.page-awards')
    .on('click', function(e) {
      var _t = $(e.target),
          el_link = _t.parents('a'),
          el_table_body = _t.parents('.award-listing-row-body');

          console.log(el_table_body)
      if (el_link.length == 1) {
        // ignore
      } else if (el_table_body.length == 1) {
        // ignore
      } else if (el_table_body.length == 0 || el_table_body.hasClass('active')) {
        $('.award-listing-row-body').removeClass('active');
        e.preventDefault();
      }
    })
    .on('click', '.award-info-title', function() {
      $(this).toggleClass('active');
    })
    .on('click', '.award-listing-header', function() {
      if ($(this).hasClass('active')) {
        $(this).toggleClass('active');
      } else {
        $('.award-listing-header').removeClass('active');
        $(this).addClass('active');
      }
    })
    .on('click', '.award-listing-table-more', function() {
      var _t = $(this),
          now_text = $('.award-listing-table-more-text', _t).text();
          chg_text = _t.attr('data-text');
      
      $('.award-listing-table-more-text', _t).text(chg_text);
      _t.attr('data-text', now_text).toggleClass('active')
        .prev().toggleClass('active');
    })
    .on('click', '.award-listing-row-body .award-listing-row', function(e) {
      if ($(e.target).parents('a').length == 1) return;

      e.preventDefault();

      var _t = $(this);

      if ($(window).width() < 1024 && _t.hasClass('active')) {
        _t.removeClass('active');
        return;
      }

      _t.addClass('active').siblings().removeClass('active');

      // update award box
      var box = _t.parents('.award-listing').find('.award-listing-box');
      // image
      var row_img = $('.award-info-row-img img', _t).attr('src') || '';
      var box_img = $('.award-info-img img', box);
      if (row_img != '') {
        box_img.attr('src', row_img).removeClass('hide');
      } else {
        box_img.attr('src', '').addClass('hide');
      }
      $('.award-info-meta .award-info-meta-tags', box).html($('.award-listing-col-region', _t).html());
      $('.award-info-meta .award-info-meta-date', box).html($('.award-listing-col-year', _t).html());
      $('.award-info-title > *', box).html($('.award-listing-col-title', _t).html());
      $('.award-info-row-details .award-info-row-text', box).html($('.award-info-row-details .award-info-row-text', _t).html());
      var link = $('.award-info-row-link .award-info-read-more', _t);
      $('.award-info-row-link .award-info-read-more', box).attr('href', link.attr('href')).attr('target', link.attr('target'));
    })
    .on('mouseenter', '.award-listing-row-body .award-listing-row', function(e) {
      e.preventDefault();

      if ($(window).width() < 1024) {
        return;
      }
      
      var _t = $(this);

      if (_t.hasClass('active')) {
        _t.removeClass('active');
        // _t.parents('.award-listing-row-body').removeClass('active');
        return;
      }

      _t.addClass('active').siblings().removeClass('active');
      // _t.parents('.award-listing-row-body').addClass('active');

      // update award box
      var box = _t.parents('.award-listing').find('.award-listing-box');
      // image
      var row_img = $('.award-info-row-img img', _t).attr('src') || '';
      var box_img = $('.award-info-img img', box);
      if (row_img != '') {
        box_img.attr('src', row_img).removeClass('hide');
      } else {
        box_img.attr('src', '').addClass('hide');
      }
      $('.award-info-meta .award-info-meta-tags', box).html($('.award-listing-col-region', _t).html());
      $('.award-info-meta .award-info-meta-date', box).html($('.award-listing-col-year', _t).html());
      $('.award-info-title > *', box).html($('.award-listing-col-title', _t).html());
      $('.award-info-row-details .award-info-row-text', box).html($('.award-info-row-details .award-info-row-text', _t).html());
      var link = $('.award-info-row-link .award-info-read-more', _t);
      $('.award-info-row-link .award-info-read-more', box).attr('href', link.attr('href')).attr('target', link.attr('target'));

    })
    // .on('touchstart mouseenter', '.award-listing-row-body .award-listing-row', function() {
    //   var _t = $(this);

    //   _t.addClass('active').siblings().removeClass('active');

    //   // update award box
    //   var box = _t.parents('.award-listing').find('.award-listing-box');
    //   $('.award-info-meta .award-info-meta-tags', box).html($('.award-listing-col-region', _t).html());
    //   $('.award-info-meta .award-info-meta-date', box).html($('.award-listing-col-year', _t).html());
    //   $('.award-info-title > *', box).html($('.award-listing-col-title', _t).html());
    //   $('.award-info-row-details .award-info-row-text', box).html($('.award-info-row-details .award-info-row-text', _t).html());
    //   var link = $('.award-info-row-link .award-info-read-more', _t);
    //   $('.award-info-row-link .award-info-read-more', box).attr('href', link.attr('href')).attr('target', link.attr('target'));
    // })
    ;
});